import React, { useMemo } from 'react';
import { Chip } from '@mui/material';
import { useSelector } from 'react-redux';
import { eplassSliceViewMode } from '../../../../../Redux/EplassSlice';
import { PdfViewerViewModeFlag } from '../../../../../pdf/Enums';
import styles from './ViewModeChip.module.scss';
import Icon from '@mdi/react';
import {
    mdiAlertCircleOutline,
    mdiCached,
    mdiEyeOutline,
    mdiFileCompare,
    mdiImage,
    mdiMicrosoftOffice,
    mdiPencilOutline,
} from '@mdi/js';
import useTranslation from '../../../../../hooks/useTranslation';

export default () => {
    const i18next_t = useTranslation();
    const viewMode = useSelector(eplassSliceViewMode);

    const cssClasses = useMemo(() => {
        switch (viewMode) {
            case PdfViewerViewModeFlag.Loading:
                return [styles.viewModeFab, styles.viewModeFabLoadingMode].join(' ');

            case PdfViewerViewModeFlag.View:
            case PdfViewerViewModeFlag.Compare:
            case PdfViewerViewModeFlag.EmailsAndOffice:
            case PdfViewerViewModeFlag.Images:
                return [styles.viewModeFab, styles.viewModeFabViewMode].join(' ');

            case PdfViewerViewModeFlag.Annotation:
                return [styles.viewModeFab, styles.viewModeFabAnnotMode].join(' ');

            case PdfViewerViewModeFlag.Error:
                return [styles.viewModeFab, styles.viewModeFabErrorMode].join(' ');
        }
    }, [viewMode]);

    const iconPath = React.useMemo(() => {
        switch (viewMode) {
            case PdfViewerViewModeFlag.Annotation:
                return mdiPencilOutline;

            case PdfViewerViewModeFlag.Compare:
                return mdiFileCompare;

            case PdfViewerViewModeFlag.EmailsAndOffice:
                return mdiMicrosoftOffice;

            case PdfViewerViewModeFlag.Error:
                return mdiAlertCircleOutline;

            case PdfViewerViewModeFlag.Images:
                return mdiImage;

            case PdfViewerViewModeFlag.Loading:
                return mdiCached;

            case PdfViewerViewModeFlag.View:
                return mdiEyeOutline;
        }
    }, [viewMode]);

    const labelText = useMemo(
        () => i18next_t(`viewModeChip.${viewMode}`, viewMode),
        [viewMode, i18next_t],
    );

    return (
        <Chip
            label={labelText}
            icon={iconPath ? <Icon path={iconPath} size={1} /> : undefined}
            className={cssClasses}
        />
    );
};
